import e from "lodash.get";
import r from "lodash.isnil";
import n from "lodash.isempty";
var t = ["BOY", "MOY", "EOY"],
  a = ["LNF", "PSF", "NWF-CLS", "NWF-WRC", "WRF", "ORF-ACC", "ORF", "MAZE"],
  i = ["CLPL", "FLO", "FLO-ACC", "FEP", "LSS", "FSS", "FSL", "FNL"],
  o = function o(e, r) {
    var n = e + r;
    return n < 0 ? 0 : n > 100 ? 100 - r : e;
  },
  u = function u(e) {
    return Math.max(0, e);
  },
  v = function v(n, t) {
    var a = n.measure,
      i = n.score,
      v = e(t, "minGain", 0),
      f = e(t, "maxGain", 0);
    return ["ORF-ACC", "FLO-ACC"].includes(a) && (v = o(v, i), f = o(f, i)), {
      min: u(i + v),
      max: r(f) ? null : u(i + f)
    };
  },
  f = function f(n, t) {
    var a = e(n, "score");
    if (r(t) || r(a)) return {};
    var i = v(n, t.find(function (e) {
        return "Average Growth" === e.growthLevel;
      })),
      o = v(n, t.find(function (e) {
        return "Above Average Growth" === e.growthLevel;
      })),
      u = v(n, t.find(function (e) {
        return "Well Above Average Growth" === e.growthLevel;
      }));
    return {
      averageRange: i,
      aboveAverageRange: o.min === u.min ? {} : o,
      wellAboveAverageRange: u
    };
  },
  s = function s(e, r, n) {
    return e.find(function (e) {
      return e.period === r && e.measure === n;
    });
  },
  l = function l(o, u, v, _l, g, c) {
    if (("lectura" === c ? i : a).includes(o) && t.includes(u)) {
      var m = {};
      switch (u) {
        case "MOY":
          m = {
            start: "BOY",
            end: "MOY"
          };
          break;
        case "EOY":
          m = {
            start: "MOY",
            end: "EOY"
          };
          break;
        default:
          m = {
            start: "BOY",
            end: "BOY"
          };
      }
      var O = s(_l, m.end, o),
        d = e(O, "goal");
      if (!r(d)) {
        if ("BOY" === u) return d;
        var A = s(v, m.start, o),
          F = s(g, m.start, o),
          h = e(F, "growthRates", null),
          L = f(A, h),
          R = L.averageRange,
          Y = L.wellAboveAverageRange;
        if (n(R) || n(Y)) return d;
        var w = R.min,
          C = Y.min;
        return Number(d >= C ? C : d >= w ? d : w);
      }
    }
  };
export { l as getStrugglingAdvancedGoalForMeasure, f as getZonesOfGrowthRanges };